require('/ui/components/breadcrumbs/breadcrumbs.module.scss.module.css');

export const list = "_list_9s7pg_1";
export const breadcrumb = "_breadcrumb_9s7pg_1";
export const smallViewportSupport = "_small-viewport-support_9s7pg_1";
export const manaBreadcrumb = "_mana-breadcrumb_9s7pg_1";
export const manaLastCrumb = "_mana-lastCrumb_9s7pg_1";
export const breadcrumbWithDropdown = "_breadcrumb-with-dropdown_9s7pg_1";
export const dropdown = "_dropdown_9s7pg_1";
